export default __webpack_public_path__ + "static/media/portfolio_bitcoin.752e7077.png";